'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
class MenuTreePreview extends PureComponent {
  get classNames() {
    return classNames('simple-menus-menu-tree', this.props.className, this.props.parentId && 'is--subtree');
  }
  renderNodes() {
    const MenuComponent = this.props.getMenuComponent(false);
    return this.props.nodes.map((node, index) => {
      return /*#__PURE__*/_jsx(MenuComponent, Object.assign({
        parentId: this.props.parentId,
        getMenuComponent: this.props.getMenuComponent
      }, node, {
        depth: this.props.depth,
        index: index,
        menuId: this.props.menuId
      }), node.id);
    });
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: this.classNames,
      children: this.renderNodes()
    });
  }
}
MenuTreePreview.propTypes = {
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  nodes: PropTypes.arrayOf(PropTypes.object),
  getMenuComponent: PropTypes.func.isRequired,
  depth: PropTypes.number.isRequired,
  className: PropTypes.string
};
export default MenuTreePreview;